// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__opLli","colMaxWidth":"Table_colMaxWidth__3aAhB"};